import React from "react";
import stepOne from "../../assets/img/fix-one.webp";
import stepTwo from "../../assets/img/fix-two.webp";
import stepThree from "../../assets/img/fix-three.webp";
import stepFour from "../../assets/img/fix-four.webp";
import stepFive from "../../assets/img/fix-five.webp";
import stepSix from "../../assets/img/fix-six.webp";
import { useNav } from "../../context/nav-context";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
const InvisalignFix = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // Trigger animations each time the element comes into view
    threshold: 0.2, // Trigger when 20% of the component is visible
  });
    const { setActiveLink } = useNav();
    // Update activeLink to "journey" when this section is in view
    useEffect(() => {
      if (inView) {
        setActiveLink("fixes");
      }
    }, [inView, setActiveLink]);
  const fixSteps = [
    {
      fixname: "Crowded teeth",
      copy: "Crowded teeth is a condition where you do not have enough room for your teeth to fit normally. This can cause plaque or tartar and other harmful bacteria to build up as it is harder for you to brush and floss well.",
      image: stepOne,
    },
    {
      fixname: "Gaps between teeth",
      copy: "Gaps between teeth is when there is extra space between two or more of your teeth. This can cause pockets between your teeth and gums and can cause food to get stuck making them tender and sore. This might also lead to gum disease.",
      image: stepTwo,
    },
    {
      fixname: "Open bite",
      copy: "An Open bite is when your upper and lower teeth don't touch when you close your mouth. An open bite can make it hard for you to chew or difficult to bite even the most common of food like apples.",
      image: stepThree,
    },
    {
      fixname: "Underbite",
      copy: "An underbite is when you close your mouth and your lower front teeth are in front of your upper teeth. In many cases, this is actually a problem with your lower jaw being too far forward. An underbite can make it hard to chew properly and speak clearly, and it might cause your teeth to wear down more quickly.",
      image: stepFour,
    },
    {
      fixname: "Overbite",
      copy: "An overbite is when your upper front teeth overlap with your lower front teeth. Most people have at least a little overbite. When your overbite is too large, your doctor might tell you you have a deep bite. This can cause problems, from your teeth wearing down to pain in your jaw.",
      image: stepFive,
    },
    {
      fixname: "Crossbite",
      copy: "A crossbite is when you close your mouth and yet some of your upper teeth are sitting inside your lower teeth rather than on the outside. A crossbite can make your teeth wear down or chip. It can also make your gums start to recede or make little notches above your gum line. This kind of damage can lead to painful gum problems or even bone loss.",
      image: stepSix,
    },
  ];
  return (
    <div id="fixes" ref={ref}>
      <div className="container mt-5">
        <h2 className="text-center mb-5">What can Alignar fix?</h2>
        <div className="row">
          {fixSteps.map((steps) => (
            <div key={steps.fixname} className="col-lg-4">
              <div className="mb-5 px-5">
                <div className="px-5">
                  <div className="mb-3">
                    <img
                      src={steps.image}
                      className="w-100"
                      alt={steps.fixname}
                    />
                  </div>
                </div>
                <h3 className="text-center">{steps.fixname}</h3>
                <p className="text-center">{steps.copy}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvisalignFix;
